<script setup>
import {computed, ref, watch, nextTick} from 'vue'
import {useFormStore} from '@/stores/form'
import {useUniqueValue} from '@/composables/useUniqueValue'
import vFormValidation from '@/vue/directives/formValidation'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"
import moment from "moment/moment"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

// Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Template refs
const input = ref(null)

// Initialize Vue 3 style composable logic
useUniqueValue(props, input)

// Computed properties
const formSmall = computed(() => {
    return formStore.value?.formSmall
})

// Watchers
watch(() => props.value, (newValue) => {
    // Fix for validation issues caused by the inconsistency between HTML's datetime-local format
    // (e.g. "2028-06-13T11:34") and MySQL's DATETIME (e.g. "2028-06-13 11:34:00")
    if (newValue && newValue.includes('T')) {
        props.currentData[props.field.name] = moment(newValue).format('YYYY-MM-DD HH:mm:ss')
    }
})

// Methods
const clearValue = () => {
    props.currentData[props.field.name] = null
    // Safari bug fix. After unsetting the value using the above, Safari still invalidates the form.
    // Setting the value a second time addresses this.
    // https://stackoverflow.com/questions/77537783/safari-datetime-local-form-validity-bug-after-unsetting-value
    nextTick(() => {
        if (input.value) {
            input.value.value = ''
        }
    })
}
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <span v-else class="d-flex-inline align-items-center">
        <input ref="input" :id="field.id" v-model="currentData[field.name]" v-select="field.autofocus" v-form-validation
               :disabled="field.disabled" :max="field.max" :min="field.min" :name="field.name"
               :required="field.required" :step="field.step" autocomplete="off" class="form-control w-auto"
               :class="{'is-invalid': field.error, 'form-control-sm': formSmall}" type="datetime-local">
        <button v-if="value" @click="clearValue" type="button" class="btn btn-link">clear</button>
    </span>
</template>